
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[page]",
      function () {
        return require("private-next-pages/page/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[page]"])
      });
    }
  